import Vue from 'vue';
import Router from 'vue-router';
import ExhibitorDirectory from './components/ExhibitorDirectory/ExhibitorDirectory.vue';

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/',
      name: 'ExhibitorDirectory',
      component: ExhibitorDirectory,
      meta: {
        isModalOpen: false,
      },
    },
    {
      path: '/favourites',
      name: 'ExhibitorFavourites',
      component: ExhibitorDirectory,
      meta: {
        isModalOpen: false,
      },
    },
    {
      path: '/:exhibitorId',
      name: 'Exhibitor',
      component: ExhibitorDirectory,
      props: true,
      meta: {
        isModalOpen: true,
      },
      children: [
        {
          path: '/:exhibitorId/news/:newsId',
          name: 'ExhibitorNews',
          component: ExhibitorDirectory,
          meta: {
            isModalOpen: true,
          },
        },
        {
          path: '/:exhibitorId/product/:productId',
          name: 'ExhibitorProducts',
          component: ExhibitorDirectory,
          meta: {
            isModalOpen: true,
          },
        },
      ],
    },
  ],
});
